'use client'
import React from 'react'
import Lottie from 'react-lottie'

import type { Options } from 'react-lottie'

import loadingAnimation from '../../../public/loading animation.json'

const Spinner = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  } satisfies Options
  return (
    <div className="spinner-container">
      <Lottie options={defaultOptions} height={72} width={72} />
    </div>
  )
}

export default Spinner
